
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-readiness",
      function () {
        return require("private-next-pages/ai-readiness.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-readiness"])
      });
    }
  